import React, {
    PropsWithChildren, useEffect, useMemo, useState,
} from 'react';

export interface ILayoutContext {
    layoutId: string;
    updateLayout: boolean;
    setUpdateLayout: (val: boolean) => void;
}

export const LayoutContext = React.createContext<ILayoutContext>({
    layoutId: '',
    updateLayout: false,
    setUpdateLayout: () => {},
});

interface ILayoutContextWrapperProps {
    layoutId: string;
}

function LayoutContextWrapper({ children, layoutId }: PropsWithChildren<ILayoutContextWrapperProps>) {
    const [updateLayout, setUpdateLayout] = useState(false);

    useEffect(() => {
        if (updateLayout) {
            setUpdateLayout(false);
        }
    }, [updateLayout]);

    const value = useMemo(() => ({
        layoutId,
        updateLayout,
        setUpdateLayout,
    }), [updateLayout]);

    return (
        <LayoutContext.Provider value={value}>
            {children}
        </LayoutContext.Provider>
    );
}

export default LayoutContextWrapper;
